const getApiUrl = () => {
  return process.env.NEXT_PUBLIC_MYSTES_API_URL ?? 'http://127.0.0.1:80'
}

export default getApiUrl